<div class="ipm-home-page-bpm " [class.ipm-container]="!isShowOnlyBanner">
    <div class="ipm-top-headng" [class.mt-0]="isShowOnlyBanner">
        <h5>Discover Top Beats this BPM Festival</h5>
        <p>Now enjoy up to 50% off for a limited time period</p>
    </div>
    <div class="ipm-banner ipm-banner-{{bannerDiscount}}-bg">
      <div class="img-wrapper">
            <img src="./assets/imgs/bpm-arena-icon/banner-offer.png" [alt]="bannerDiscount+'_image'">
        </div>
    </div>
   <div class="imp-mobile-banner">
        <div class="img-wrapper">
            <img src="./assets/imgs/bpm-arena-icon/banner-offer-mobile.png" [alt]="bannerDiscount+'_image'">
        </div>
    </div>
  <div class="top-beats-header" *ngIf="!isShowOnlyBanner">
    <h2 class="heading-title">
      Top Beats
      <span>✨</span>
    </h2>
    <button class="play-all-btn" [id]="'ipm-beat-list-'+bannerDiscount" [attr.aria-label]="'Play all beats from grid'" (click)="gotoLatestBeat()" id="{{bannerDiscount}}">
      <span class="btn-text">Play All</span>
      <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
        focusable="false">
        <path d="M4 9h8M10 7l2 2-2 2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="ipm-beats-bpm-secion" *ngIf="!isShowOnlyBanner">
    <ipm-common-section [type]="'bpmArena'" [heading]="''" [bpmBeatsList]="beatListData"></ipm-common-section>
  </div>
</div>